import { ADMIN_MANAGED_PERMISSIONS, permissionsPayload, TradeLimit, User } from '@protos/user';
import { getLondonEndOfDayLabel, getTimeDifferenceGranular, isLondonTimeZone } from '@shared/utils/date';
import { snakeToTitleCase } from '@utils/string';
import { format } from 'date-fns';

function formatExpiryDate(expiry: string, dateFormat: string) {
  const date = new Date(expiry);

  const expiryDateLabel = format(date, dateFormat);

  if (!isLondonTimeZone()) {
    const londonTimeExpiryLabel = getLondonEndOfDayLabel(date, dateFormat);
    return `${expiryDateLabel} ${londonTimeExpiryLabel}`;
  }

  return expiryDateLabel;
}

export function getExpiryDateLabel(expiry: string, isMobile: boolean) {
  return formatExpiryDate(expiry, isMobile ? 'd MMM ‘yy' : 'dd MMM yyyy');
}

export const convertName = (value: string) => {
  const newValue = value.charAt(0).toUpperCase() + value.slice(1);
  return newValue.replace('_', ' ');
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const liveSocketGridColumnDefs = [
  {
    headerName: 'Client Type',
    field: 'client_type',
  },
  {
    headerName: 'Current Time',
    field: 'current_time',
  },
  {
    headerName: 'Last Message Received',
    field: 'last_message_received',
  },
  {
    headerName: 'Last Message Sent',
    field: 'last_message_sent',
  },
  {
    headerName: 'Messages Received',
    field: 'message_received',
  },
  {
    headerName: 'Messages Sent',
    field: 'message_sent',
  },
  {
    headerName: 'Protocol',
    field: 'protocol',
  },
  {
    headerName: 'Remote IP',
    field: 'remote_ip',
  },
  {
    headerName: 'Socket UID',
    field: 'socket_uid',
  },
  {
    headerName: 'Started',
    field: 'started',
  },
  {
    headerName: 'Age',
    valueGetter: params => {
      const now = new Date().toISOString();
      const started = params.data?.started ?? 0;
      return getTimeDifferenceGranular(started, now);
    },
  },
];
export const getCurrentUser = (user: User) => {
  return {
    trade_limits: user.trade_limits,
    ladder_limits: user.ladder_limits,
    permissions: permissionsPayload(
      user.permissions,
      user.permissions.filter(permission => ADMIN_MANAGED_PERMISSIONS.includes(permission))
    ),
    trading_accounts: user.trading_accounts,
  };
};

export const tradeLimitsList = (tradeLimits: TradeLimit[], allowOrderTypes = false) => {
  if (!tradeLimits) return [];
  return tradeLimits.map(({ symbol, limit, exchange, order_types }) => {
    const formattedSymbol = symbol.toLocaleUpperCase();
    const formattedExchange = String(exchange).toLocaleUpperCase();
    const formattedOrderTypes = allowOrderTypes ? `: ${snakeToTitleCase(String(order_types))}` : '';
    const formattedTradeLimit = `${formattedSymbol} : ${limit} : ${formattedExchange} ${formattedOrderTypes}`;
    return formattedTradeLimit;
  });
};
